import { mapToolTypes, ToolType } from "./ToolType";

export interface ToolCategoryList {
    id?: number;
    category_name?: string;
    path?: string | null;
    status?: 1 | 0;
    tool_type?: ToolType[];
}

// to single object maping
export const mapToolCategoryList = (data:any): ToolCategoryList => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: ToolCategoryList ={
        id: data.id,
        category_name: data.category_name,
        path: data.path,
        status: data.status,
        tool_type: mapToolTypes(data.tool_type),
    }
    return res;
}

// maping list objects
export const mapToolCategoryLists = (data:any[]): ToolCategoryList[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapToolCategoryList);
}